<template>
  <v-row justify="center" align="center" v-if="conversations">
    <v-col cols="12">
      <v-row justify="center" align="center">
        <v-col lg="6" cols="12" sm="6" md="6">
          <MixedCarts :dataSource="dataSource" v-if="!loading" />
        </v-col>

        <v-col lg="6" cols="12" sm="6">
          <MixedCarts :dataSource="dataSource1" />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import MixedCarts from "../charts/ApexCartsMixed.vue";
export default {
  name: "concersation_status",
  components: {
    MixedCarts,
  },
  data() {
    return {
      loading: false,
      monthNames: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      dataSource: {
        height: 350,
        type: "bar",
        series: [
          {
            name: "Conversation number",
            type: "column",
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            height: 350,
            type: "bar",
          },
          stroke: {
            show: true,
            curve: "smooth",
            lineCap: "butt",
            colors: undefined,
            width: 2,
            dashArray: 0,
          },
          dataLabels: {
            enabled: true,
            enabledOnSeries: [0],
          },
          labels: [],
          legend: {
            show: true,
            showForSingleSeries: true,
            showForNullSeries: true,
            showForZeroSeries: true,
            position: "bottom",
            horizontalAlign: "center",
            floating: false,
            fontSize: "14px",
          },
          xaxis: {
            type: "date",
          },
          yaxis: [
            {
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: "#008FFB",
              },
              labels: {
                style: {
                  colors: "#008FFB",
                },
              },
              title: {
                text: "Conversations Number",
                style: {
                  color: "#008FFB",
                },
              },
              tooltip: {
                enabled: true,
              },
            },
          ],
        },
      },
      dataSource1: {
        height: 350,
        type: "bar",
        series: [
          {
            name: "",
            type: "column",
            data: [],
          },
          {
            name: "",
            type: "column",
            data: [],
          },
        ],
        chartOptions: {
          colors: ["#E91E63", "#33a5fc"],
          chart: {
            height: 350,
            type: "column",
          },
          stroke: {
            show: true,
            curve: "smooth",
            lineCap: "butt",
            colors: undefined,
            width: 2,
            dashArray: 0,
          },
          dataLabels: {
            enabled: true,
            enabledOnSeries: [0, 1],
            formatter: function (val) {
              return val.toFixed(2) + "%";
            },
          },
          labels: [],
          legend: {
            show: true,
            showForSingleSeries: true,
            showForNullSeries: true,
            showForZeroSeries: true,
            position: "bottom",
            horizontalAlign: "center",
            floating: false,
            fontSize: "14px",
          },
          xaxis: {
            type: "date",
          },
          yaxis: [
            {
              seriesName: "% Bot messages",
              opposite: false,
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: "#E91E63",
              },
              labels: {
                style: {
                  colors: "#E91E63",
                },
                formatter: function (val) {
                  return val ? val.toFixed(1) : val + "%";
                },
              },
              title: {
                text: "% Bot messages",
                style: {
                  color: "#E91E63",
                },
              },
              tooltip: {
                enabled: true,
              },
            },
            {
              seriesName: "% Admin messags",
              opposite: true,
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: "#33a5fc",
              },
              labels: {
                style: {
                  colors: "#33a5fc",
                },
                formatter: function (val) {
                  return val ? val.toFixed(1) : val + "%";
                },
              },
              title: {
                text: "% Admin messages",
                style: {
                  color: "#33a5fc",
                },
              },
              tooltip: {
                enabled: true,
              },
            },
          ],
        },
      },
    };
  },
  computed: {
    conversations() {
      const data = this.$store.state.analytics.Conversations;
      return data;
    },
  },
  async created() {
    this.loading = true;
    if (this.conversations) await this.init_vals();
    this.loading = false;
  },
  methods: {
    init_vals() {
      if (
        this.conversations &&
        this.conversations !== "Their is no conversation for this given period"
      ) {
        console.log(this.conversations);
        this.conversations.map((element) => {
          this.dataSource.chartOptions.labels.push(
            `${this.monthNames[element.month - 1]} - ${element.year}`
          );
          this.dataSource.series[0].data.push(
            element.nb_distinct_conversations
          );
          this.dataSource.series[0].name = this.$t(
            "analytics.conversations.number_conversations.graph_elements.conversation_number"
          );

          this.dataSource1.chartOptions.labels.push(
            `${this.monthNames[element.month - 1]} - ${element.year}`
          );
          const val1 =
            (element.nb_messages_bot / element.nb_messages_total) * 100;
          const val2 =
            (element.nb_messages_admin / element.nb_messages_total) * 100;
          this.dataSource1.series[0].data.push(val1.toFixed(2));
          this.dataSource1.series[0].name = this.$t(
            "analytics.conversations.message_detail.nb_messages_bot"
          );
          this.dataSource1.series[1].data.push(val2.toFixed(2));
          this.dataSource1.series[1].name = this.$t(
            "analytics.conversations.message_detail.nb_messages_admin"
          );
        });
        console.log(this.conversations);
      }
    },
  },
};
</script>
